import { h, Component } from "preact";
import { Link } from "preact-router/match";
import { translate } from "react-i18next";

class Navigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileNavToggled: false,
    };
  }

  createCookie = (name, value, days) => {
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      let expires = "; expires=" + date.toGMTString();
      document.cookie = name + "=" + value + expires + ";domain=.hirezstudios.com;path=/";
    } else {
      let expires = "";
      document.cookie = name + "=" + value + expires + ";domain=.hirezstudios.com;path=/";
    }
  };

  toggleNav = () => {
    this.state.mobileNavToggled
      ? this.setState({ mobileNavToggled: false })
      : this.setState({ mobileNavToggled: true });
  };

  addWindowClickListener = () => {
    window.addEventListener("click", this.closeMenu);
  };

  closeMenu = () => {
    this.state.mobileNavToggled ? this.setState({ mobileNavToggled: false }) : "";
  };

  eraseCookie = (name) => {
    this.createCookie(name, "", -1);
  };

  componentDidUpdate(prevProps) {
    console.log(this.state.mobileNavToggled);
  }

  logoutUser = () => {
    localStorage.removeItem("linkRedirectUrl");
    this.eraseCookie("HZAcctTokenExp");
    this.eraseCookie("HZAcctUsername");
    this.eraseCookie("HZAcctWebToken");
    this.eraseCookie("HZRegion");
    this.eraseCookie("HZAcctID");
    location.reload();
  };

  readCookie = (name) => {
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  };

  componentDidMount() {
    this.addWindowClickListener();
  }

  componentDidUpdate() {
    if (this.props.windowWidth < 1200) {
      //This measures how far to push the main window over when the mobile nav is open.
      this.state.mobileNavToggled
        ? document
            .getElementsByClassName("wrapped-content")[0]
            .setAttribute(
              "style",
              `transform: translateX(${
                document.getElementById("mobile").offsetWidth -
                (document.body.offsetWidth - document.getElementsByClassName("center-wrapper")[0].offsetWidth) / 2
              }px);`
            )
        : document.getElementsByClassName("wrapped-content")[0].setAttribute("style", `transform: translateX(0);`);
    } else {
      this.state.mobileNavToggled ? this.setState({ mobileNavToggled: false }) : "";
      document.getElementsByClassName("wrapped-content")[0].setAttribute("style", `transform: translateX(0);`);
    }
  }

  render() {
    const { userData } = this.context;
    const { t } = this.props;
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <div className="nav-trigger" onClick={this.toggleNav}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125">
            <path d="M45.7,84.7c-1.2,0-2.3-0.4-3.2-1.3c-1.8-1.8-1.8-4.6,0-6.4l27-27l-27-27c-1.8-1.8-1.8-4.6,0-6.4c1.8-1.8,4.6-1.8,6.4,0 l30.2,30.2c1.8,1.8,1.8,4.6,0,6.4L48.9,83.4C48.1,84.2,46.9,84.7,45.7,84.7z" />
            <path d="M24.1,84.7c-1.2,0-2.3-0.4-3.2-1.3c-1.8-1.8-1.8-4.6,0-6.4l27-27l-27-27c-1.8-1.8-1.8-4.6,0-6.4c1.8-1.8,4.6-1.8,6.4,0 l30.2,30.2c1.8,1.8,1.8,4.6,0,6.4L27.3,83.4C26.4,84.2,25.2,84.7,24.1,84.7z" />
          </svg>
        </div>
        <nav className={`primary ${this.state.mobileNavToggled ? "mobile-nav-active" : ""}`}>
          <Link activeClassName="active" href="/">
            <i className="icon-account" />
            {t("Account Info")}
          </Link>
          <Link activeClassName="active" href="/security">
            <i className="icon-security" />
            {t("Security")}
          </Link>
          <Link activeClassName="active" href="/linked-accounts">
            <i className="icon-account" />
            {t("Linked Accounts")}
          </Link>
          {/* <a rel="noopener noreferrer" target="_blank" href="https://support.hirezstudios.com/">
            <i className="icon-support" />
            {t("Submit Support Ticket")}
          </a> */}
          {this.props.isVIP && (
            <Link
              activeClassName="active"
              className={"vip " + (this.props.chatActive ? "chat-active" : "")}
              href="/vip-chat"
            >
              <i className="icon-vip" />
              {t("VIP Chat")}
            </Link>
          )}
          <Link activeClassName="active" href="/other-settings">
            <i className="icon-settings" />
            {t("Other Settings")}
          </Link>
          <Link activeClassName="active" onClick={this.logoutUser}>
            <i className="icon-logout" />
            {t("Logout")}
          </Link>
        </nav>
        <nav id="mobile" class={`mobile ${this.state.mobileNavToggled ? "mobile-nav-active" : ""}`}>
          <div className="user-info">
            <p>{this.readCookie("HZAcctUsername")}</p>
          </div>
          <Link activeClassName="active" href="/" onClick={() => this.handleClick()}>
            <i className="icon-account" />
            {t("Account Info")}
          </Link>
          <Link activeClassName="active" href="/security" onClick={() => this.handleClick()}>
            <i className="icon-security" />
            {t("Security")}
          </Link>
          <Link activeClassName="active" href="/linked-accounts" onClick={() => this.handleClick()}>
            <i className="icon-account" />
            {t("Linked Accounts")}
          </Link>
          {/* <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://support.hirezstudios.com/"
            onClick={() => this.handleClick()}
          >
            <i className="icon-support" />
            {t("Submit Support Ticket")}
          </a> */}
          {this.props.isVIP && (
            <Link
              activeClassName="active"
              className={"vip " + (this.props.chatActive ? "chat-active" : "")}
              href="/vip-chat"
              onClick={() => this.handleClick()}
            >
              <i className="icon-vip" />
              {t("VIP Chat")}
            </Link>
          )}
          <Link activeClassName="active" href="/other-settings" onClick={() => this.handleClick()}>
            <i className="icon-settings" />
            {t("Other Settings")}
          </Link>
          <Link activeClassName="active" onClick={this.logoutUser} href="/">
            <i className="icon-logout" />
            {t("Logout")}
          </Link>
          <div className="nav-trigger back" onClick={this.toggleNav}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125">
              <path d="M45.7,84.7c-1.2,0-2.3-0.4-3.2-1.3c-1.8-1.8-1.8-4.6,0-6.4l27-27l-27-27c-1.8-1.8-1.8-4.6,0-6.4c1.8-1.8,4.6-1.8,6.4,0 l30.2,30.2c1.8,1.8,1.8,4.6,0,6.4L48.9,83.4C48.1,84.2,46.9,84.7,45.7,84.7z" />
              <path d="M24.1,84.7c-1.2,0-2.3-0.4-3.2-1.3c-1.8-1.8-1.8-4.6,0-6.4l27-27l-27-27c-1.8-1.8-1.8-4.6,0-6.4c1.8-1.8,4.6-1.8,6.4,0 l30.2,30.2c1.8,1.8,1.8,4.6,0,6.4L27.3,83.4C26.4,84.2,25.2,84.7,24.1,84.7z" />
            </svg>
          </div>
        </nav>
      </div>
    );
  }
}

export default translate(["common"], { withRef: true })(Navigation);



// WEBPACK FOOTER //
// ./components/Navigation.js